module.exports = __webpack_public_path__ + "img/yaoyong.c74be96d.jpg";